(function () {
  const ACTIVE = 'active';
  const SUB_ACTIVE = 'sub-active';
  const OPEN = 'open';
  const TOR_MENU_AIM = '.tor-aim-menu';

  // Mobile menu state
  const mobileState = {
    defaultHref: 'javascript:void(0)',
    lvl2: { label: '', href: '', cssClass: '' },
    lvl3: { label: '', href: '', cssClass: '' }
  };

  // Cached elements
  let menuMobileLinkBack, menuMobileLinkParent, hamburgerIcon, menuMobile, mobileSearch;

  document.addEventListener('DOMContentLoaded', function () {
    const mainNav = document.querySelector('.nav-main');
    if (!mainNav) return;

    const mainNavListItems = document.querySelectorAll('.nav-main__list-item');
    const submenuListItems = document.querySelectorAll(`.nav-main__submenu:not(${TOR_MENU_AIM}) .nav-main__submenu-item`);

    // Cache mobile elements
    menuMobileLinkBack = document.querySelector('#menuMobileLinkBack');
    menuMobileLinkParent = document.querySelector('#menuMobileLinkParent');
    hamburgerIcon = document.querySelector('.hamburger-icon');
    menuMobile = document.querySelector('.tor-header__menu-mobile');
    mobileSearch = document.querySelector('.tor-header-mobile__search');

    // Desktop nav events
    mainNavListItems.forEach(item => {
      item.addEventListener('mouseenter', e => {
        if (!item.classList.contains(ACTIVE) && !e.target.classList.contains('nav-overlay')) {
          item.classList.add(ACTIVE);
        }
      });
      item.addEventListener('mouseleave', () => {
        item.classList.remove(ACTIVE);
        item.querySelectorAll('.' + SUB_ACTIVE).forEach(el => el.classList.remove(SUB_ACTIVE));
      });
    });

    submenuListItems.forEach(item => {
      item.addEventListener('mouseenter', () => item.classList.add(SUB_ACTIVE));
      item.addEventListener('mouseleave', () => item.classList.remove(SUB_ACTIVE));
    });

    function setSubmenuHeight() {
      mainNavListItems.forEach(item => {
        const subMenu = document.querySelector('.nav-main__submenu', item);
        const subMenuSecond = document.querySelectorAll('.nav-main__submenu-second', item);
        if (!subMenuSecond.length) return;

        let maxHeight = 0;
        if (subMenu) subMenu.style.display = 'block';

        subMenuSecond.forEach(subItem => {
          const savedStyle = subItem.getAttribute('style');
          subItem.style.display = 'block';

          const navCollection = document.querySelector('.nav-collection', subItem);
          let height = 0;
          if (navCollection) {
            const styles = getComputedStyle(navCollection);
            height = navCollection.offsetHeight + parseInt(styles.marginTop) + parseInt(styles.marginBottom);
          }

          savedStyle ? subItem.setAttribute('style', savedStyle) : subItem.removeAttribute('style');
          height += parseInt(getComputedStyle(subItem).paddingTop);
          if (height > maxHeight) maxHeight = height;
        });

        if (subMenu) {
          subMenu.removeAttribute('style');
          subMenu.style.minHeight = (maxHeight + 20) + 'px';
        }
      });
    }

    function loadImages(elem) {
      document.querySelectorAll('.nav-collection__image', elem).forEach(link => {
        const src = link.dataset.img;
        if (src && !link.querySelector('img')) {
          const img = document.createElement('img');
          img.src = src;
          link.appendChild(img);
        }
      });
    }

    // Resize handler with debounce
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setSubmenuHeight();
        if (window.innerWidth > 991 && document.body.classList.contains('nav-open')) {
          toggleMobileMenu();
        }
      }, 100);
    });

    setSubmenuHeight();

    // Mobile menu
    const hamburger = document.querySelector('.hamburger');
    if (hamburger) {
      hamburger.addEventListener('click', toggleMobileMenu);
    }

    function toggleMobileMenu() {
      hamburgerIcon?.classList.toggle(OPEN);
      document.body.classList.toggle('nav-open');

      if (!document.body.classList.contains('nav-open')) {
        resetMobileMenu();
      }

      menuMobile?.classList.toggle(OPEN);
      if (menuMobile?.classList.contains(OPEN) && mobileSearch) {
        mobileSearch.style.display = 'none';
      }
    }

    function resetMobileMenu() {
      document.body.classList.remove('nav-open');
      document.querySelectorAll('.nav-mobile__list').forEach(el => el.classList.remove('open-lvl-2', 'open-lvl-3', 'open-lvl-4'));
      document.querySelectorAll('.tor-header__menu-mobile-wrap .nav-collection__list').forEach(el => el.style.display = 'none');
      document.querySelectorAll('.tor-header__menu-mobile .open').forEach(el => el.classList.remove(OPEN));
      setMobileLinkDefaults();
    }

    function setMobileLinkDefaults() {
      if (menuMobileLinkBack) {
        menuMobileLinkBack.innerHTML = '';
        menuMobileLinkBack.href = mobileState.defaultHref;
        menuMobileLinkBack.classList.add('back-link-disabled');
      }
      if (menuMobileLinkParent) {
        menuMobileLinkParent.innerHTML = '&nbsp;';
        menuMobileLinkParent.href = mobileState.defaultHref;
        menuMobileLinkParent.classList.remove('parent-link-active');
        menuMobileLinkParent.classList.add('parent-link-disabled');
      }
    }

    // Level 1 click
    document.querySelectorAll('.nav-mobile__list-link').forEach(link => {
      link.addEventListener('click', function (e) {
        const next = this.nextElementSibling;
        if (next?.classList.contains('nav-mobile__submenu-wrap')) {
          e.preventDefault();
          e.stopPropagation();
          this.parentElement.classList.add(OPEN);
          this.parentElement.parentElement.classList.add('open-lvl-2');

          mobileState.lvl2 = {
            label: this.textContent,
            href: this.getAttribute('href') || mobileState.defaultHref,
            cssClass: this.getAttribute('href') ? 'parent-link-active' : 'parent-link-disabled'
          };

          if (menuMobileLinkParent) {
            menuMobileLinkParent.innerHTML = mobileState.lvl2.label;
            menuMobileLinkParent.href = mobileState.lvl2.href;
            menuMobileLinkParent.classList.remove('parent-link-disabled', 'parent-link-active');
            menuMobileLinkParent.classList.add(mobileState.lvl2.cssClass);
          }

          if (menuMobileLinkBack) {
            menuMobileLinkBack.textContent = mobileState.lvl2.label;
            menuMobileLinkBack.classList.remove('back-link-disabled');
            menuMobileLinkBack.onclick = () => {
              document.querySelectorAll('.nav-mobile__list-item.open').forEach(el => el.classList.remove(OPEN));
              document.querySelectorAll('.nav-mobile__list').forEach(el => el.classList.remove('open-lvl-2'));
              setMobileLinkDefaults();
              menuMobileLinkBack.onclick = null;
            };
          }
        }
      });
    });

    // Level 2 click
    document.querySelectorAll('.nav-mobile__submenu-item a').forEach(link => {
      link.addEventListener('click', function (e) {
        const next = this.nextElementSibling;
        if (next?.classList.contains('nav-mobile__submenu-second')) {
          e.preventDefault();
          e.stopPropagation();
          const parent = this.parentElement;
          const isOpen = parent.classList.contains(OPEN);
          
          // Close other open submenus
          document.querySelectorAll('.nav-mobile__submenu-item.open').forEach(el => {
            if (el !== parent) el.classList.remove(OPEN);
          });
          
          // Toggle current submenu
          parent.classList.toggle(OPEN);
          
          // Toggle lvl-3 class based on new state
          document.querySelectorAll('.open-lvl-2').forEach(el => {
            if (isOpen) {
              el.classList.remove('open-lvl-3');
            } else {
              el.classList.add('open-lvl-3');
            }
          });
        }
      });
    });

    // Simple link class
    document.querySelectorAll('.nav-mobile__submenu-item > a').forEach(link => {
      if (!link.nextElementSibling?.classList.contains('nav-mobile__submenu-second')) {
        link.classList.add('link-simple');
      }
    });

    document.querySelectorAll('.tor-header__menu-mobile-wrap .nav-collection__title').forEach(title => {
      if (!title.nextElementSibling?.classList.contains('nav-collection__list')) {
        title.classList.add('link-simple');
      }
    });

    // Search button
    const btnSearch = document.querySelector('#btnMenuMobileSearch');
    btnSearch?.addEventListener('click', () => {
      if (mobileSearch) {
        const isHidden = mobileSearch.offsetParent === null;
        mobileSearch.style.display = isHidden ? 'block' : 'none';
        if (isHidden) menuMobile?.classList.remove(OPEN);
      }
    });

    setMobileLinkDefaults();
  });
})();